import React from 'react';
import type { ViewProps } from 'react-native';

export function Raw({ children }: ViewProps) {
  return <>{children}</>;
}
